'use client';
import * as React from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

export interface SelectedCollectionProps {
  placeholderData?: {
    name: string;
    image: string | undefined;
  };
  address: string;
  tokenId: number;
  name: string;
  image: string;
  isFree?: boolean | undefined;
  isDiscount?: boolean | undefined;
  discountPercentage?: number | undefined;
  tokensHold?: number;
  count?: number;
}

export interface SelectedCollectionDataContextType {
  selectedCollectionDetails: SelectedCollectionProps;
  setSelectedCollectionData(
    f: SelectedCollectionProps | ((prev: SelectedCollectionProps) => SelectedCollectionProps)
  ): void;
}

const SelectedCollectionDataContext = createContext<SelectedCollectionDataContextType>(
  {} as SelectedCollectionDataContextType
);

export const useSelectedCollectionDetails = () => {
  return useContext(SelectedCollectionDataContext);
};

export const SelectedCollectionDetailsProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedCollectionDetails, setSelectedCollectionData] = useState<SelectedCollectionProps>({
    address: '',
    image: '',
    name: '',
    placeholderData: {
      image: '',
      name: ''
    },
    tokenId: 0,
    discountPercentage: 0,
    isDiscount: false,
    isFree: false
  });

  const values = useMemo<SelectedCollectionDataContextType>(() => {
    return {
      selectedCollectionDetails,
      setSelectedCollectionData
    } as SelectedCollectionDataContextType;
  }, [selectedCollectionDetails, setSelectedCollectionData]);

  return <SelectedCollectionDataContext.Provider value={values}>{children}</SelectedCollectionDataContext.Provider>;
};
